/* jshint ignore:start */

var HighlightsCarouselManager = (function ($) {
    // console.log("llamada a config idioma");
    var instance;

    function init() {

        var _$highlightsCarousel;

        var intervalsIds = [];

        function initFlickityNewWeb() {

            if ($(".js-module_slider_flip-flip")) {
                initFlickityFlip();
            }

            if ($(".js-flickity-content-info")) {
                initFlickityInfo();
            }

            if ($(".js-flickity-curved")) {
                initFlickityCurved();
            }

            if ($(".js-flickity-basic")) {
                initFlickityBasic();
            }

            if ($(".js-flickity-double")) {
                initFlickityDouble();
            }

        }

        function initFlickityDouble() {
            $(".js-flickity-double").each(function (indexContent) {
                var $ele = $(this);
                var totalItems = $ele.data('total');
                
                $ele.flickity({
                    pageDots: false,
                    wrapAround: true,
                    imagesLoaded: true,
                    prevNextButtons: (totalItems > 1 ? true : false)
                });

            });
        }

        function initFlickityBasic() {
            $('.js-flickity-basic').each(function () {
                var $ele = $(this);
                var totalItems = $ele.data('total');
                $ele.flickity({
                    pageDots: false,
                    adaptiveHeight: true,
                    imagesLoaded: true,
                    prevNextButtons: (totalItems > 1 ? true : false)
                });

            });
        }

        function initFlickityFlip() {
            $('.js-flickity-flip').each(function () {
                var $ele = $(this);
                var totalItems = $(this).data('total');
                var around = $(this).data('around');
                console.log('totalItems', totalItems);
                $(this).flickity({
                    pageDots: false,
                    imagesLoaded: true,
                    prevNextButtons: (totalItems > 1 ? true : false),
                    wrapAround: (around == 1 ? true : false),
                    on: {
                        ready: function () {

                            // console.log('Flickity is ready');
                        },
                        change: function (index) {
                        }
                    }
                });

            });
        }

        function initFlickityInfo() {
            $(".js-flickity-content-info").each(function (indexContent) {
                var $content = $(this);
                var timeChange = $content.data('time');
                var numRefresh = 20;

                var $carousel = $(this).find('.js-flickity-info').flickity({
                    pageDots: false,
                    wrapAround: true,
                    draggable: true,
                    on: {
                        ready: function () {
                            initTimerSlider($content, 0, timeChange, indexContent, numRefresh);
                            // console.log('Flickity is ready');
                        },
                        change: function (index) {
                            // console.log( 'Slide changed to' + index );
                            initTimerSlider($content, index, timeChange, indexContent, numRefresh);
                        }
                    }
                });
            });
        }

        function initFlickityCurved() {
            $(".js-flickity-curved-element").each(function (indexContent) {
                $(this).find(".js-flickity-curved").flickity({
                    pageDots: false,
                    adaptiveHeight: true,
                    wrapAround: true
                });
            });
        }

        function clearProgressAfterChange($content, indexInterval, indexNew, numRefresh) {
            var oldIndex = indexNew - 1;
            if (oldIndex >= 0) {
                var $ele = $content.find('.js-progression-' + oldIndex);
                $ele.css("width", '100%');
                $ele.data('counter', numRefresh);
            }

            clearInterval(intervalsIds[indexInterval]);

        }

        function initTimerSlider($content, index, timeChange, indexInterval, numRefresh) {
            clearProgressAfterChange($content, indexInterval, index, numRefresh);

            if (index == 0) {
                $content.find('.js-progression').css("width", '0%');
                $content.find('.js-progression').data("counter", '0');
            }

            $content.find('.js-progression').data("counter", '0');

            $content.find('.js-slideinfo-progress-action').removeClass("active");
            $content.find('.js-slideinfo-progress-'+ index +' .js-slideinfo-progress-action').addClass("active");

            

            var intervalID = setInterval(changeProgress, (timeChange / numRefresh), $content, index, timeChange, indexInterval, numRefresh);
            intervalsIds[indexInterval] = intervalID;
        }

        function changeProgress($content, index, timeChange, intervalIndex, numRefresh) {
            var $ele = $content.find('.js-progression-' + index);
            var counter = $ele.data('counter');
            counter++;

            var progress = (counter * (100 / numRefresh));

            $ele.css("width", progress + '%');

            $ele.data('counter', counter);
            $ele.data('intervalID', intervalIndex);

            if (counter >= numRefresh) {
                clearInterval(intervalsIds[intervalIndex]);

                $content.find('.js-flickity-info').flickity('next');
            }

        }


        return {
            initFlickity: function () {
                var highlightsNavigationLinkSelector = '.highlights__navigation-link',
                    $highlightsItems = $('.highlights__item');

                var $flktyHighlights = $('.js-highlights-carousel').flickity({
                    on: {
                        ready: function () {
                            $highlightsItems.addClass('highlights__item--ready');
                        }
                    },
                    draggable: true,
                    // cellAlign: 'left',
                    imagesLoaded: true,
                    groupCells: true,
                    contain: true,
                    wrapAround: true,
                    autoPlay: true,
                    arrowShape: {
                        x0: 10,
                        x1: 60, y1: 50,
                        x2: 65, y2: 45,
                        x3: 20
                    }
                    // pageDots: false,
                    // prevNextButtons: false,
                });

                var flickity = $flktyHighlights.data('flickity');

                var $flktyHighlightsNav = $('.highlights__navigation');
                var $flktyHighlightsNavItems = $flktyHighlightsNav.find(highlightsNavigationLinkSelector);

                $flktyHighlights.on('select.flickity', function () {

                    $flktyHighlightsNav.find('.highlights__navigation-link--selected').removeClass('highlights__navigation-link--selected');
                    $flktyHighlightsNavItems.eq(flickity.selectedIndex).addClass('highlights__navigation-link--selected');
                });

                $flktyHighlightsNav.on('click', highlightsNavigationLinkSelector, function (ev) {
                    ev.preventDefault();

                    var index = $(this).index(highlightsNavigationLinkSelector);
                    $flktyHighlights.flickity('select', index);
                });
            },



            init: function () {
                initFlickityNewWeb();
                // _$highlightsCarousel = $('.js-highlights-carousel');
                // if (_$highlightsCarousel.length) {
                //     // console.log('noticias carousel inittttt');
                //     // this.initFlickity();
                // }

            }
        };
    }


    return {

        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */


/******** FLIP CAROUSEL *****/

function changeSlideClasses(slide, method, className) {
    if (!slide) {
        return;
    }
    slide.getCellElements().forEach(function (cellElem) {
        cellElem.classList[method](className);
    });
}

Flickity.createMethods.push('_createPrevNextCells');

Flickity.prototype._createPrevNextCells = function () {
    this.on('select', this.setPrevNextCells);
};

Flickity.prototype.setPrevNextCells = function () {

    var flickityClassName = this.element.className;

    if (flickityClassName.indexOf('js-flickity-flip') > -1) {
        // remove classes
        changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
        changeSlideClasses(this.nextSlide, 'remove', 'is-next');
        // set slides
        this.previousSlide = this.slides[this.selectedIndex - 1];
        this.nextSlide = this.slides[this.selectedIndex + 1];
        // add classes
        changeSlideClasses(this.previousSlide, 'add', 'is-previous');
        changeSlideClasses(this.nextSlide, 'add', 'is-next');
    }

    if (flickityClassName.indexOf('js-flickity-number') > -1) {
        console.log('es flip');

        // remove classes
        changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
        changeSlideClasses(this.nextSlide, 'remove', 'is-next');
        // set slides
        this.previousSlide = this.slides[this.selectedIndex - 1];
        this.nextSlide = this.slides[this.selectedIndex + 1];
        // add classes
        changeSlideClasses(this.previousSlide, 'add', 'is-previous');
        changeSlideClasses(this.nextSlide, 'add', 'is-next');
    }

    if (flickityClassName.indexOf('js-flickity-curved') > -1) {

        // remove classes
        changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
        changeSlideClasses(this.nextSlide, 'remove', 'is-next');
        // set slides
        var previousI = fizzyUIUtils.modulo(this.selectedIndex - 2, this.slides.length);
        var nextI = fizzyUIUtils.modulo(this.selectedIndex + 3, this.slides.length);
        this.previousSlide = this.slides[previousI];
        this.nextSlide = this.slides[nextI];
        // add classes
        changeSlideClasses(this.previousSlide, 'add', 'is-previous');
        changeSlideClasses(this.nextSlide, 'add', 'is-next');
    }


};


